export default __webpack_public_path__ + "static/media/Activity6.3edafd04.jpeg";